import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "@progress/kendo-react-layout";
import { Button, Col, List, Row } from "reactstrap";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import { EventParticipantsInfo } from "./EventParticipantsInfo";

function EventParticipantFields(props) {
  const { t } = useTranslation();
  const [fields, setFields] = useState([]);
  const [visibleParticipantsInfo, setVisibleParticipantsInfo] = useState(false);

  function toggleDialogEditParticipantsInfo() {
    setVisibleParticipantsInfo(!visibleParticipantsInfo);
  }

  useEffect(() => {
    getSelectedFields();
  }, []);

  function getSelectedFields() {
    ParticipantService.getParticipantFields().then((fieldData) => {
      ParticipantService.getEventParticipantFieldsByEventId(
        props.event.etkinliK_TANIM_ID
      ).then((eventFieldData) => {
        var newFieldData = fieldData.map((f) => {
          f.selected = eventFieldData.fields.find(
            (s) => s.alaN_KODU === f.alaN_KODU
          )
            ? true
            : false;
          return f;
        });
        setFields(newFieldData);
      });
    });
  }

  return (
    <Card style={{ flex: 1 }}>
      {visibleParticipantsInfo ? (
        <EventParticipantsInfo
          toggleDialog={toggleDialogEditParticipantsInfo}
          title={t("event_participants_info")}
          event={props.event}
          fields={fields}
          getSelectedFields={getSelectedFields}
        ></EventParticipantsInfo>
      ) : (
        ""
      )}
      <CardHeader>
        <CardTitle>
          <i class="fa fa-calendar"></i>{" "}
          {t("information_requested_participants")}{" "}
          <Button
            color="primary"
            type="button"
            size="sm"
            onClick={toggleDialogEditParticipantsInfo}
          >
            <i className="fa fa-edit"></i> {t("select")}
          </Button>
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            <List type="unstyled">
              {fields
                .filter((f) => f.selected)
                .map((f) => (
                  <li>
                    <i class="fa fa-check-square"></i> <b>{f.alaN_ADI}</b>
                  </li>
                ))}
            </List>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export { EventParticipantFields };
